/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtoresetpasswordpleasecheckyourcodeandtryagain10Inputs */

const en_failedtoresetpasswordpleasecheckyourcodeandtryagain10 = /** @type {(inputs: Failedtoresetpasswordpleasecheckyourcodeandtryagain10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to reset password. Please check your code and try again.`)
};

const de_failedtoresetpasswordpleasecheckyourcodeandtryagain10 = /** @type {(inputs: Failedtoresetpasswordpleasecheckyourcodeandtryagain10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Passwort konnte nicht zurückgesetzt werden. Prüf deinen Code und versuch's nochmal.`)
};

/**
* | output |
* | --- |
* | "Failed to reset password. Please check your code and try again." |
*
* @param {Failedtoresetpasswordpleasecheckyourcodeandtryagain10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtoresetpasswordpleasecheckyourcodeandtryagain10 = /** @type {((inputs?: Failedtoresetpasswordpleasecheckyourcodeandtryagain10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtoresetpasswordpleasecheckyourcodeandtryagain10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtoresetpasswordpleasecheckyourcodeandtryagain10(inputs)
	return de_failedtoresetpasswordpleasecheckyourcodeandtryagain10(inputs)
});
export { failedtoresetpasswordpleasecheckyourcodeandtryagain10 as "failedToResetPasswordPleaseCheckYourCodeAndTryAgain" }